import {Model} from "@vuex-orm/core";
import ToolState from "./ToolState";
import Tool from "./Tool";

export default class ToolStateHistory extends Model {
  static entity = 'toolstatehistories';

  static $fetch() {
    return this.api().get('ToolStateHistory/')
  }
  static $fetchByTool(toolid, daterange) {
    return this.api().get(`ToolStateHistory/?tool=${toolid}&date_range=${daterange}`)
  }
  static $get (id) {
    return this.api().get(`ToolStateHistory/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ToolStateHistory/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ToolStateHistory/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      state: this.belongsTo(ToolState, "state_id"),
      state_id: this.attr(null),
      tool: this.belongsTo(Tool,"tool_id"),
      tool_id: this.attr(null),
      created: this.attr(""),
      span: this.number(0),
      current: this.boolean(true)
    }
  }

  // Mutations
  static mutators() {
    return {
      span (value) {
        return value = Math.round(value * 1e2) / 1e2
      },
      created (value) {
        return new Date(value).toLocaleString()
      }
    }
  }

  // Gets the current history object and creates a dynamic span since that DB does not have a completion date
  get dynamicSpan() {
    if (this.current) {
      let spanMilli = (Math.abs(new Date() - new Date(this.created)));
      spanMilli = (spanMilli / 86400000);
      spanMilli = Math.round(spanMilli * 1e2) / 1e2;
      return spanMilli
    } else {
      return this.span
    }
  }

  static historyByState(state, tool) {
    return this.query()
      .where("state_id", parseInt(state))
      .where("tool_id", parseInt(tool))
      .sum("dynamicSpan");
  }
}
